"use client";

import React from "react"
import { OpenGraphSEO } from "./OpenGraphSEO"
import PageSEO from "./PageSEO"

interface Props {
  title: string
  description: string
  icon?: string
  cover?: string
  siteName: string
  url: string
  noIndex?: boolean
  noFollow?: boolean
}

export const PageMetadata = ({
  title,
  description,
  icon,
  cover,
  siteName,
  url,
  noIndex,
  noFollow,
}: Props) => {
  return (
    <>
      <PageSEO
        description={description}
        icon={icon}
        noFollow={noFollow}
        noIndex={noIndex}
        title={title}
      />
      <OpenGraphSEO
        description={description}
        title={title}
        type=""
        cover={cover}
        siteName={siteName}
        url={url}
      />
    </>
  )
}
